module.exports = __webpack_public_path__ + "static/media/banner1.1b70cbd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Home/components/imgs/banner1.png
// module id = 1281
// module chunks = 0